(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'LogEntriesService', [ '$window', LogEntriesService ]);


    /**
     * Exposes log-entries JS library to the app. See
     * https://github.com/rapid7/le_js
     *
     * @returns {LogEntries}
     */
    function LogEntriesService( $window ){





        /* ===== PRIVATE MEMBERS ============================================ */


        // See https://github.com/rapid7/le_js/wiki/API
        var options = {
            token:      '114aab30-e943-40ae-8e54-255fb18a78fb',
            ssl:        true,
            //trace:      true,
            //no_format:  false,
            page_info:  'per-page',
            catchall:   true
        };





        /* ===== RUN ON INSTANTIATION ======================================= */


        (function init(){
            $window.LE.init( options );
        })();





        ////////////////////////////////////////////////////////////////////

        return $window.LE; // Expose API

        ////////////////////////////////////////////////////////////////////

    }
})();
